import { useState } from 'react'

import Button from '../../Button'
import { ConfirmationModal } from '../../Confirmation'
import { InputField } from '../../Input'
import { Container } from '../Container'

import ModalSizeL from './ModalL'
import ModalSizeM from './ModalSizeM'
import ModalSizeS from './ModalSizeS'
import ModalSizeXl from './ModalXl'
import ModalSizeXlCreate from './ModalXlCreate'

function Modals() {
  const [isConfirmationOpen, setConfirmationOpen] = useState(false)

  return (
    <>
      <ModalSizeS>
        <InputField label='Input label' />
      </ModalSizeS>
      <ModalSizeS>
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
      </ModalSizeS>
      <ModalSizeM>
        <InputField label='Input label' />
      </ModalSizeM>
      <ModalSizeM>
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
      </ModalSizeM>
      <Container label='Confirmation modal'>
        <Button.Contained
          text='Open modal'
          onClick={() => setConfirmationOpen(true)}
        />
        {isConfirmationOpen ? (
          <ConfirmationModal
            actionButtonsProps={{
              cancelText: 'Go back',
              submitText: 'Cancel',
            }}
            description='Cancel without saving?'
            title='Attention'
            onCancel={() => setConfirmationOpen(false)}
            onSubmit={() => setConfirmationOpen(false)}
          />
        ) : null}
      </Container>
      <ModalSizeL>
        <InputField label='Input label' />
      </ModalSizeL>
      <ModalSizeL>
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
      </ModalSizeL>
      <ModalSizeXl>
        <InputField label='Input label' />
      </ModalSizeXl>
      <ModalSizeXl>
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
      </ModalSizeXl>
      <ModalSizeXlCreate>
        <InputField label='Input label' />
      </ModalSizeXlCreate>
      <ModalSizeXlCreate>
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
        <InputField label='Input label' />
      </ModalSizeXlCreate>
    </>
  )
}

export default Modals
